package portalmodels

import hardware.HardwareFeature
import kotlinx.serialization.Serializable

@Serializable
data class HardwareVersionFeatureDTO(
    val settings: Map<Int, List<HardwareFeature>>
)